<aur-mat-table [tableConfig]="tableConfig"
               [tableData]="tableData"
               (rowAction)="onRowAction($event)"></aur-mat-table>
